<script setup lang="ts">
import { PhHandbag, PhTag, PhToggleRight } from '@phosphor-icons/vue';
</script>
<template>
	<div class="px-3xl flex flex-col gap-7xl">
		<h1 class="text-lg font-semibold">How Rewards Work?</h1>

		<div class="flex gap-xl">
			<div class="border h-fit rounded-sm p-xl">
				<PhHandbag size="24" weight="fill" />
			</div>
			<div class="flex flex-col gap-xs">
				<h2 class="text-base font-medium">Earn.</h2>
				<h3 class="text-sm font-normal text-gray-600">
					Earn rewards on every purchase that you make.
				</h3>
			</div>
		</div>

		<div class="flex gap-xl">
			<div class="border h-fit rounded-sm p-xl">
				<PhToggleRight size="24" weight="fill" />
			</div>
			<div class="flex flex-col gap-xs">
				<h2 class="text-base font-medium">Spend.</h2>
				<h3 class="text-sm font-normal text-gray-600">
					Switch the toggle on checkout to redeem rewards.
				</h3>
			</div>
		</div>

		<div class="flex gap-xl">
			<div class="border h-fit rounded-sm p-xl">
				<PhTag size="24" weight="fill" />
			</div>
			<div class="flex flex-col gap-xs">
				<h2 class="text-base font-medium">Enjoy discounts..</h2>
				<h3 class="text-sm font-normal text-gray-600">
					Avail discounts on your purchase!
				</h3>
			</div>
		</div>
	</div>
</template>
